import {
  AdminSpinner,
  ArrowRed,
  BestPerformingProviderEntity,
  Box,
  Div,
  getDashboardBestPerformingProviders,
  H5,
  Icon,
  lightTheme,
  ModalPortal,
  BestPerformingPlaceholder,
  BestPerformingProviderComponent,
  reportError,
} from '@vgrubs/components';
import { Dispatch, SetStateAction, useEffect, useState } from 'react';
import { useInView } from 'react-intersection-observer';

async function getBestPerformingProviders(
  page: number,
  bestPerformingProviders: BestPerformingProviderEntity[] | null,
  setBestPerformingProviders: Dispatch<
    SetStateAction<BestPerformingProviderEntity[] | null>
  >,
  hasMore: boolean,
  setHasMore: Dispatch<SetStateAction<boolean>>,
  setPage: Dispatch<SetStateAction<number>>,
  setLoading: Dispatch<SetStateAction<boolean>>
) {
  if (!hasMore) return;
  setLoading(true);

  const LIMIT = 10;

  try {
    const { data } = await getDashboardBestPerformingProviders({
      page,
      limit: LIMIT,
    });

    if (bestPerformingProviders === null) {
      setBestPerformingProviders(data.data);
    } else {
      setBestPerformingProviders((prev) => [...(prev || []), ...data.data]);
    }

    setHasMore(data.data.length === LIMIT);
    setPage(page + 1);
  } catch (error) {
    reportError(error);
  } finally {
    setLoading(false);
  }
}

export const BestPerformingProvidersSection = () => {
  const [loading, setLoading] = useState(false);
  const [loadingMore, setLoadingMore] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [bestPerformingProviders, setBestPerformingProviders] = useState<
    BestPerformingProviderEntity[] | null
  >(null);
  const [hasMore, setHasMore] = useState(true);
  const [page, setPage] = useState(1);
  const [ref, inView] = useInView();

  useEffect(() => {
    setPage(1);
    setHasMore(true);
    // setBestPerformingProviders(null);
    getBestPerformingProviders(
      1,
      null,
      setBestPerformingProviders,
      true,
      setHasMore,
      setPage,
      setLoading
    );
  }, []);

  useEffect(() => {
    if (inView && hasMore) {
      getBestPerformingProviders(
        page,
        bestPerformingProviders,
        setBestPerformingProviders,
        hasMore,
        setHasMore,
        setPage,
        setLoadingMore
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inView]);

  return (
    <>
      <Box $p="16px 20px" $relative $overflow="hidden">
        {loading && <AdminSpinner small absolute creme />}
        {bestPerformingProviders?.length ? (
          <Icon
            $pointer
            style={{ position: 'absolute', right: 16, top: 16 }}
            onClick={() => setIsOpen(true)}
            color={lightTheme.lightGray}
          >
            <ArrowRed />
          </Icon>
        ) : null}
        <H5 $mb="16">Best Performing 3PDs</H5>

        {bestPerformingProviders?.slice(0, 5).map((item, index) => (
          <BestPerformingProviderComponent
            key={index}
            item={item}
            index={index}
          />
        ))}

        <BestPerformingPlaceholder
          length={bestPerformingProviders?.length || 0}
        />
      </Box>
      <ModalPortal
        isOpen={isOpen}
        closeModal={() => setIsOpen(false)}
        backgroundColor={lightTheme.white}
        padding="24px"
        logo={false}
        width="600px"
        maxHeight="calc(65px * 10)"
        modalOverflow="hidden"
        titleWithExit="Best Performing 3PDs"
      >
        {loadingMore && <AdminSpinner small absolute />}

        {bestPerformingProviders?.map((item, index) => (
          <BestPerformingProviderComponent
            key={index}
            item={item}
            index={index}
          />
        ))}
        <Div $height="20px" ref={ref}></Div>
      </ModalPortal>
    </>
  );
};
